import { render, staticRenderFns } from "./deleteChainProduct.vue?vue&type=template&id=1fefdd3e"
import script from "./deleteChainProduct.vue?vue&type=script&lang=js"
export * from "./deleteChainProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports